import { env } from '@/env';

export function isAuthDisabled() {
    return env.VUE_APP_DISABLE_AUTH === 'true';
}
